<template>
  <div class="cart-widget">
    <div class="widget-header" :class="{spinner: loading}">{{$t("shop.checkout.order_details")}}</div>
    <div class="widget-content">
      <dl>
        <dt>{{$t("shop.checkout.subtotal")}}</dt>
        <dd>{{$store.state.cart.total}} AMD</dd>

        <dt v-if="shipping_method.price>0">{{$t("shop.checkout.shipping_cost")}}</dt>
        <dd v-if="shipping_method.price>0">{{shipping_method.price}} AMD</dd>

        <dt v-if="sale>0">{{$t("shop.checkout.sale")}}</dt>
        <dd v-if="sale>0" class="summary-info"><span :data-content="$t('shop.checkout.sale_info')">?</span>{{sale}} AMD</dd>

        <dt v-if="coupon_sale>0">{{$t("shop.checkout.coupon")}} <span class="remove_coupon" @click="remove_coupon()">{{$t("shop.checkout.remove_coupon")}}</span></dt>
        <dd v-if="coupon_sale>0" class="summary-info"><span :data-content="'Կուպոնի մնացորդ՝ '+coupon_balance+'AMD'" v-if="coupon_balance>0">?</span>{{coupon_sale}} AMD</dd>
      </dl>
      <div class="coupon-code">
        <span v-if="!show_coupon" @click="show_coupon=true">{{$t("shop.checkout.add_coupon")}}</span>
        <div class="coupon-form" v-else>
          <div class="coupon-input"><input type="text" v-model="coupon.name" :placeholder="$t('shop.checkout.enter_your_coupon')"></div>
          <div class="apply-coupon">
            <button @click="apply_coupon()">{{$t("shop.checkout.apply_coupon")}}</button>
          </div>
        </div>
        <div class="coupon-msg" v-if="coupon_msg!=false">{{$t('shop.checkout.errors.' + coupon_msg )}}</div>
      </div>
    </div>
    <div class="widget-footer">
      <dl>
        <dt>{{$t("shop.checkout.grand_total")}}</dt>
        <dd>{{grand_total}} AMD</dd>
      </dl>
    </div>
    <form id="redirect_to_idram" style="display: none" action="https://money.idram.am/payment.aspx" method="POST">
      <input type="hidden" name="EDP_LANGUAGE" value="HY">
      <input type="hidden" name="EDP_REC_ACCOUNT" id="EDP_REC_ACCOUNT" value="110000669">
      <input type="hidden" name="EDP_DESCRIPTION" id="EDP_DESCRIPTION">
      <input type="hidden" name="EDP_AMOUNT" :value="grand_total">
      <input type="hidden" name="EDP_BILL_NO" id="EDP_BILL_NO">
      <input type="submit" value="submit">
    </form>

  </div>
</template>

<script>
import Api from '@/services/api-service';
import { mapState } from 'vuex';

export default {
  props: ['loading', 'shipping_method'],
  data () {
    return {
      show_coupon: false,
      coupon_sale: 0,
      coupon_msg: false,
      coupon_name: '',
      coupon_balance: 0
    };
  },
  methods: {
    apply_coupon () {
      this.coupon_msg = false;
      Api.post('/apply-coupon', {
        coupon: this.coupon.name
      })
        .then(response => {
          if (response.data.status === 'success') {
            this.$store.dispatch('fetchCoupon', response.data.coupon);
          } else {
            this.coupon_sale = 0;
            this.coupon_msg = response.data.message;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    remove_coupon () {
      this.$store.dispatch('fetchCoupon', {
        name: '',
        msg: false,
        coupon_amount: 0,
        discount_type: null,
        disabled: true
      });
    },
    calc_coupon_amount () {
      let couponAmount;
      if (this.coupon.discount_type === 'fixed') {
        couponAmount = this.coupon.coupon_amount;
      } else if (this.coupon.discount_type === 'percentage') {
        couponAmount = (this.cart_total * this.coupon.coupon_amount) / 100;
      }
      if (couponAmount) {
        if (this.total >= couponAmount) {
          this.coupon_sale = couponAmount;
          this.coupon_balance = 0;
        } else {
          this.coupon_sale = this.total;
          this.coupon_balance = Number(couponAmount) - this.total;
        }
      } else {
        this.coupon_sale = 0;
      }
    }
  },
  created () {
    // eslint-disable-next-line eqeqeq
    if (this.coupon.name !== '') {
      this.show_coupon = true;
      this.coupon_name = this.coupon.name || '';
      this.calc_coupon_amount();
    } else {
      this.coupon_name = '';
      this.coupon_sale = 0;
    }
  },
  computed: {
    ...mapState(['coupon']),
    orderNumber: () => {
      return Math.floor(Math.random() * 99999999);
    },
    shipping () {
      return Number(this.shipping_method.price) || 0;
    },
    cart_total () {
      return Number(this.$store.state.cart.total) || 0;
    },
    sale () {
      let isGiftCardInCart = false;
      let cartQtyItems = 0;
      this.$store.state.cart.items.forEach((e) => {
        cartQtyItems += e.qty;
        if (e.giftCart === 1) {
          isGiftCardInCart = true;
        }
      });
      if (!isGiftCardInCart && cartQtyItems >= 2) {
        return 2000;
      }
      return 0;
    },
    sub_total () {
      return this.cart_total + this.shipping;
    },
    total () {
      let total = this.sub_total - this.sale;
      return total > 0 ? total : 0;
    },
    grand_total () {
      this.calc_coupon_amount();
      let grandTotal = this.total - this.coupon_sale;
      return grandTotal > 0 ? grandTotal.toFixed(2) : 0;
    },
    ...mapState({
      coupon: state => state.checkout.coupon
    })
  },
  watch: {
    'coupon' (to, from) {
      // eslint-disable-next-line eqeqeq
      if (to.name !== '') {
        this.show_coupon = true;
        this.coupon_name = to.name || '';
      } else {
        this.coupon_name = '';
        this.coupon_sale = 0;
      }
      this.calc_coupon_amount();
    }
  }
};
</script>
